import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";
import PlaceholderImage from "../../atoms/placeholder-image";

import "./card-image-type-8.m.css";

const CardImageType8 = ({ story }) => {
  const getAuthorId = get(story, ["authors", 0, "id"], story["author-id"]);
  const slug = story["hero-image-s3-key"];
  const storyImageSlug = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${story.slug}`}>
      <div styleName="wrapper" className="card-image-type-1">
        {storyImageSlug ? (
          <CardImage story={story} defaultWidth={36} aspectRatio={[16, 9]} imageType="image16x9" />
        ) : (
          <PlaceholderImage story={story} />
        )}
        <Headline story={story} headerType={3} headerLevel={3} />
        {story["author-name"] && (
          <p styleName="author-byline">
            <span>By </span>
            <Link href={`/author/${getAuthorId}`}>{story["author-name"]}</Link>
          </p>
        )}
      </div>
    </Link>
  );
};

export default CardImageType8;

CardImageType8.propTypes = {
  story: object
};
